<template>
  <b-form-group
    v-if="!dataLoad"
    label="Status"
  >
    <b-form-select
      v-model="taksStatus"
      :options="taksStatusOptions"
      trim
      @change="$emit('handleTaksStatus', taksStatus)"
    />

  </b-form-group>
</template>

<script>

export default {
  props: {
    dataLoad: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      taksStatus: this.$route.query.statusTask || '',
      taksStatusOptions: [
        { value: 'pending', text: 'New Pending' },
        { value: 'completed', text: 'Completed' },
        { value: 'cancelled', text: 'Cancelled' },
        { value: 'in-progress', text: 'In Progress' },
      ],
    }
  },
}
</script>
